export default class InternalInsurancePage {
    constructor() {
        this.init();
    }

    styleHTMLBackground() {
        document.getElementsByTagName('html')[0].style.background = "#fafafa";
    }

    init() {
        if (document.body.className.indexOf('internal-use') != -1) {
            this.styleHTMLBackground();
        }
    }
}
